import { formatPrice } from "@/lib/formatPrice";

interface CategoryItem {
  name: string;
  count: number;
  revenue: number;
}

interface DashboardTopCategoriesProps {
  categories: CategoryItem[];
}

export default function DashboardTopCategories({ categories }: DashboardTopCategoriesProps) {
  return (
    <div className="bg-white rounded-xl border border-border/60">
      <div className="px-5 py-3 border-b border-border/60">
        <p className="text-sm font-semibold">Najprodavanije kategorije</p>
      </div>
      <div className="divide-y divide-border/60">
        {categories.length === 0 ? (
          <p className="px-5 py-4 text-sm text-muted-foreground">Nema podataka</p>
        ) : (
          categories.map((cat) => (
            <div
              key={cat.name}
              className="px-5 py-2.5 text-sm flex items-center gap-3"
            >
              <div className="flex-1 min-w-0">
                <p className="font-medium truncate">{cat.name}</p>
              </div>
              <div className="text-right shrink-0">
                <p className="tabular-nums">{cat.count} kom</p>
                <p className="text-muted-foreground tabular-nums text-xs">
                  {formatPrice(cat.revenue)} KM
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
